import script from "./CopropertyIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopropertyIndex.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__